<template>
  <kst-page-new
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details :userData="userData"/>
    <TransactionSetting :userData="userData"/>
    <Addresses :userAddresses="userAddresses"/>
  </kst-page-new>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../CliModel.js";
import Services from "../../../services/Api/ClientServices.js";

import Details from "./CliN_Details.vue";
import Addresses from "./CliN_Addresses.vue";
import TransactionSetting from "./CliN_TransactionSetting.vue";

export default {
  components: {
    Details,
    Addresses,
    TransactionSetting
  },
  mixins: [InputPageMixin],
  data: () => ({
    userData: {},
    userAddresses: []
  }),
  methods: {
    /*** by page ***/

    handleInit(loadNew) {
      this.resetData();

      const config = Services.getNewData();
      loadNew(config);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData, this.userAddresses);
      const config = Services.postData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.userAddresses = [];
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>